module.exports = __webpack_public_path__ + "media/luxury-2026/drone-video-interior-960-29c309d9.jpg";